import { IBaseComponentProps } from '../types';
import { IItemRenderProps, IListViewProps } from '../listview/listview-types';
import { ICalloutProps } from '../callout';

export interface IDropdownItemRenderProps extends IItemRenderProps {
    data: IDropdownOption;
    toggleSelectAll(): void;
}

export interface IDropdownProps extends IBaseComponentProps<HTMLDivElement>,
    Omit<React.HTMLProps<HTMLInputElement>, 'as' | 'ref'>,
    Pick<IListViewProps, 'loadOnDemand' | 'initialItems' | 'onFetchMoreItems' | 'itemsIterator'>,
    Pick<ICalloutProps, 'disableRefocusTarget'> {
    /**
     * Default selected keys
     */
    defaultSelectedKeys?: React.Key | React.Key[];
    /**
     * In disabled state
     */
    disabled?: boolean;
    /**
     * In error state
     */
    error?: boolean;
    /**
     * Sets option width to field width
     */
    fitOptionWidthToFieldWidth?: boolean;
    /**
     * Id of the dropdown
     */
    id?: string;
    /**
     * Label of the dropdown
     */
    label?: string;
    /**
     * Allows multiselect within the dropdown
     */
    multiSelect?: boolean;
    /**
     * Items to display in the dropdown
     */
    items?: IDropdownOption[];
    /**
     * Item height
     */
    itemHeight?: number;
    /**
     * Placeholder for the dropdown field
     */
    placeholder?: string;
    /**
     * Required
     */
    required?: boolean;
    /**
     * Placeholder for the dropdown search field
     */
    searchPlaceHolder?: string;
    /**
     * Selected keys will be displayed in the dropdown.
     */
    selectedKeys?: React.Key | React.Key[];
    /**
     * Separtor separtes the items which are selected in multiselect mode, defaults to ','
     */
    separator?: string;
    /**
     * Shows 'select all' field
     */
    showSelectAll?: boolean;
    /**
     * Shows search box when enabled.
     */
    showSearchBox?: boolean;
    /**
     * Label for 'select all' field
     */
    selectAllLabel?: string;
    /**
     * Search icon will be hidden in the search box when enabled
     */
    hideSearchIcon?: boolean;
    /**
     * Loads a spinner when enabled
     */
    loading?: boolean;
    /**
     * onRenderItem handler
     */
    onRenderItem?(itemProps: IDropdownItemRenderProps): React.ReactNode;
    /**
     * onValueChange handler
     */
    onValueChange?(selectedKeys: React.Key[], selectedValues?: IDropdownOption[]): void;
    /**
     * Search box value change handler
     */
    onSearchTextChange?(searchText: string): void;
}

export interface IDropdownOption {
    key: React.Key;
    text: string;
    value?: any;
    type?: Omit<OptionType, OptionType.SelectAll>;
}

export enum OptionType {
    OptionGroup,
    SelectAll
}
